import { useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { RouteProps } from '@PorkyCol/layouts/dist/esm/types';
import { Dashboard } from '@PorkyCol/layouts';
import useNavConfig from '@hooks/useNavConfig';
import { useAuthContext } from '@hooks/useAuthContext';
import { useDisclosure } from '@nextui-org/react';
import { Header } from './header';
import Main from './Main';

export default function DashboardLayout() {
  const { isOpen, onOpenChange, onOpen } = useDisclosure();
  const { isInitialized } = useAuthContext();
  const navigate = useNavigate();
  const dashboardRef = useRef();
  const { lastNav } = useNavConfig();
  console.log('lastNav', lastNav);
  if (!isInitialized) {
    return <h1>Loading...</h1>;
  }
  return (
    <>
      <Header handleOpen={onOpen} />
      <Dashboard
        headerProps={{
          name: '',
          role: '',
        }}
        ref={dashboardRef}
        onlyMobile
        showHeader={false}
        routesProps={{
          items: lastNav as RouteProps['items'],
          defaultSelectedKey: 'home',
          onSelected: (key) => {
            if (typeof key === 'string') navigate(key);
          },
        }}
        controls={{
          isOpen,
          onOpenChange,
          onOpen,
        }}
      >
        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          <Main>
            <Outlet />
          </Main>
        </Box>
      </Dashboard>
    </>
  );
}
